import styled from 'styled-components';

import IconTimCard from 'components/icons/tims-card';
import TextButton from 'components/text-button';

import SectionHeading from '../section-heading';
import { SectionContainer } from '../styled';

export const PaymentSelection = styled.div`
  margin: 1rem 0;

  ${Styles.mobileFullscreen`
    margin-bottom: calc(50px + 1rem);
  `}
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f4efe9;
  padding: 0.5rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0.5rem 0;
`;

export const StyledSectionHeading = styled(SectionHeading)`
  display: inline;
  color: ${Styles.color.secondary};
  font-size: 1.5rem;
  opacity: 0.7;
`;

export const StyledPayWithTC = styled.div`
  border-radius: ${Styles.borderRadius};
  border: 1px solid ${Styles.color.grey.four};
  padding: 1.5rem 1rem 1rem;
  ${Styles.desktop`
      padding: 1.5rem 2rem 1rem;
  `}
`;

export const StyledTextButton = styled(TextButton)`
  padding: 0.875rem 0;
`;

export const StyledIconTimCard = styled(IconTimCard)`
  fill: ${Styles.color.primary};
`;

export const SmallText = styled.p`
  font-size: 0.875rem;
  margin: 0.375rem 0.875rem 0.875rem;
`;

export const ErrorContainer = styled.div`
  margin-top: 1rem;
  background-color: #fae7ea;
  text-align: center;
`;

export const ErrorMessage = styled.p`
  margin: 0 2rem;
  padding: 0.7rem 0;
  color: ${Styles.color.primary};
`;

export const CartPriceTooLow = styled.div`
  text-align: center;
  padding: 1rem;
`;

export const PaymentSectionContainer = styled(SectionContainer)`
  border: none;
  ${Styles.desktop`
    padding: 0;
  `}
`;

export const PaymentSection = styled.div<{ ref?: React.RefObject<HTMLDivElement> }>`
  width: 100%;
  max-width: 480px;
  margin: 2rem auto 0;
  padding: 0 1rem;
`;

interface IAddNewCardWrapper {
  addMargin: boolean;
}

export const AddNewCardWrapper = styled.div<IAddNewCardWrapper>`
  margin-top: ${p => (p.addMargin ? '0.625rem' : 0)};
`;

export const SignUpToContinueDisclaimer = styled.p`
  font-size: 0.85rem;
  font-weight: ${Styles.fontWeight.normal};
  text-align: center;
  margin-bottom: 2rem;
`;
